import { getCookie, identifyDevicePlatform } from "./src/util/utils";

// (function () {


// 	setInterval(() => {
// 		_l_();
// 	}, 60 * 1000)

// 	function _l_() {
// 		const xhr = new XMLHttpRequest();
// 		xhr.open("GET", `/api/is_in_white_list?href=${location.pathname}`)
// 		xhr.send()
// 		xhr.onload = function () {
// 			console.log(xhr.response)
// 			const res = JSON.parse(xhr.response)
// 			if (res.result) {
// 				window.location.href = `/?show_login=true?redirect_url=${location.href}`
// 			}
// 		}
// 	}

// })()
const getkey = (key) => {
	let queryPram = window.location.href.split("?")[1];
	let pram = new URLSearchParams("?" + queryPram);
	let value = pram.get(key);
	if (!value) return null;
	// 空格转为+
	// return value.replaceAll(/[\s]/g, '+');
	return value.replace(/\s/g, '+');
};


(function () {
	_u_();
	function _g_(cname) {
		var name = cname + "=";
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i].trim();
			if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
		}
		return "";
	}

	setInterval(() => {
		_l_();
	}, 60 * 1000)


	function _l_() {
		// const xhr = new XMLHttpRequest();
		// xhr.open("GET", `/api/is_in_white_list?href=${location.pathname}`)
		// xhr.send()
		// xhr.onload = function () {
		// 	console.log(xhr.response)
		// 	const res = JSON.parse(xhr.response)
		// 	if (res.result) {
		// 		window.location.href = `/?show_login=1?redirect_url=${location.href}`
		// 	}
		// }
	}
	function setRecordMenu() {
		var xhr = new XMLHttpRequest();
		xhr.open('POST', '/api/recordMenuActivity', true);
		xhr.setRequestHeader('Content-Type', 'application/json');
		var data = { menu: window.location.pathname };
		if (data.menu == "/team_home.html") {
			data.clientId = getkey('clientId')
		}
		xhr.send(JSON.stringify(data));
		xhr.onload = () => { }
		xhr.onreadystatechange = (e) => {
			const request = e.target;
			if (request.readyState === 4 && request.status !== 200) {
				console.error('recordMenuActivity', request.status)
			}
		}
	}

	function setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		const expires = "expires=" + d.toGMTString();
		const href = window.location.href;
		let str = '.bujue.art';
		if (href.indexOf('.panzitech.com') >= 0) {
			str = '.panzitech.com';
		}
		if (href.indexOf('.ngtest.guyubao.com') >= 0) {
			str = '.ngtest.guyubao.com'
		}

		if (href.indexOf('.ngrok.xiaomiqiu123.top') >= 0) {
			str = '.ngrok.xiaomiqiu123.top'
		}
		document.cookie = `${cname} = ${cvalue} ;${expires} ;domain=${str}; path=/`;
	}
	function errorCatch(event) {
		fetch('/api/errorCatch/create', {
			headers: {
				"content-type": "application/json",
			},
			method: "POST",
			body: JSON.stringify({
				creatorId: window.__user__?.id,
				userAgent: navigator.userAgent,
				message: event?.message + ' / ' + `url=${location.href}`
			}),
		}).then((res) => res.json());
		event.preventDefault();

		// const isEdge = /Edge\/\d+/.test(navigator.userAgent) || /Edg/.test(navigator.userAgent);
		// const isChrome = /chrome/.test(navigator.userAgent?.toLowerCase()) && /google inc/.test(navigator.vendor);
		// if(isEdge){
		// 	if(event?.message === "Uncaught NotFoundError: Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node."){
		// 		alert('暂时不兼容Edge浏览器的翻译功能！建议关闭网页的翻译功能后再使用');
		// 		return false 

		// 	}
		// }
		// if(!isChrome){
		// 	alert('建议更换为google浏览器后再使用');
		// 	return false
		// }
		return false;
	}
	const lsgysPage = ['/material_square.html', '/material_login.html', '/', '/product_detail.html', '/product.html', '/create_detail.html', '/supplier.html/', '/supplier.html', '/shop.html', '/supplier_settle.html', '/supply_stop.html', '/examine_result.html', '/settle_agree.html', '/settle_form.html', '/product_detail_share.html']
	function _u_() {
		// replaceAll兼容低版本
		String.prototype.replaceAll = function (s1, s2) {
			return this.replace(new RegExp(s1, "gm"), s2);
		}
		// 监听错误事件
		window.onerror = function (message, source, lineno, colno, error) {
			// 构建错误信息对象
			var errorInfo = {
				message: message,
				source: source,
				lineno: lineno,
				colno: colno,
				stack: error && error.stack
			};

			// alert(JSON.stringify(errorInfo));
		};

		window.onunhandledrejection = function (e) {
			// 捕获Promise拒绝引起的错误
			e.preventDefault();
			var error = e.reason;

			// 构建错误信息对象
			var errorInfo = {
				message: error.message,
				stack: error.stack
			};

			// 将错误信息发送到服务器
			// alert(JSON.stringify(errorInfo));
		};
		let user;
		Object.defineProperty(window, '__user__', {
			get: function () {
				return user; // 返回属性值  
			},
			set: function (newValue) {
				user = newValue
				window.dispatchEvent(new Event('userChange'))
			},
			configurable: true
		});
		var xhr = new XMLHttpRequest();
		const token = _g_("mtoken")
		const queryPram = window.location.href.split("?")[1];
		let pram = new URLSearchParams("?" + queryPram);
		const entrust = pram.get("entrust");
		if (!token || location.href.indexOf("/login.html?show_login") !== -1) {
			return;
		}
		// queryUserByToken 请求前先确保 platform cookie 已就位：已有则复用，没有按设备类型兜底
		if (!getCookie('platform')) {
			setCookie('platform', identifyDevicePlatform() !== 'phone' ? 'MATERIAL' : 'MATERIAL_H5', 7);
		}
		xhr.open("GET", `/api/queryUserByToken?token=${token}`)
		xhr.send();
		xhr.onload = () => {
			if (_g_("mtoken") !== token) return;
			window.__user__ = JSON.parse(xhr.response);
			window.localStorage.setItem("user", xhr.response)
			const obj = JSON.parse(xhr.response)
			const pathname = window.location.pathname;
			if (obj?.identityType == 2) {
				setCookie('fromSquare', true, 7);
				// if (!lsgysPage.includes(pathname)) {
				// 	window.location.replace('/material_square.html');
				// }
			} else {
				setCookie('fromSquare', false, 7);
				// console.log(window.__user__,pathname)
				// 访客 清掉token
				let okUrlArray = [`/team_home.html`, '/team.html/', '/product_detail.html','/international.html/','/share_app_page.html']
				if (okUrlArray.includes(pathname) == false && obj?.id == 0) {
					setCookie('mtoken', '', 7);
				}
			}
			//记录页面访问
			if (obj?.id != 0 && obj?.id) setRecordMenu();
		}
		xhr.onreadystatechange = (e) => {
			const request = e.target;
			if (_g_("mtoken") !== token) return;
			if (request.readyState === 4 && request.status !== 200) {
				setCookie('fromSquare', '', 7);
				// 切换成浏览模式
				setCookie('isReady', 1,1);
				const token2 = _g_("token")
				if (window.__user__?.identityType == 2) {
					if (!token2 && !token) {
						setCookie('mtoken', '', 7);
						window.__user__ = null;
						window.localStorage.setItem("user", '{}');
					}
					window.location.replace('/login.html?isSquare=1');
				}
				if (entrust) {
					if (!token2 && !token) {
						setCookie('mtoken', '', 7);
						window.__user__ = null;
						window.localStorage.setItem("user", '{}');
					}

					window.location.replace("/login.html?entrust=" + entrust);
				}
				if (!token2 && !token) {
					setCookie('mtoken', '', 7);
					window.__user__ = null;
					window.localStorage.setItem("user", '{}');
				}
			}
		}
		window.addEventListener('error', errorCatch)
	}
})()
